import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js'
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock'

import { closeSearch } from './search-overlay.js'

gsap.registerPlugin(ScrollToPlugin)

const elNavDrawer = document.querySelector('[data-nav-drawer]')
const elNavDrawerToggle = document.querySelector('[data-nav-drawer-toggle]')
let dropdownToggles
let primaryLinks
let elFirstLink
let elLastLink

/**
 * Handle opening the nav and setting accessibility attributes and handlers
 */
const openNavDrawer = () => {
    // Close the search dropdown if it's open
    if (document.body.getAttribute('data-search-open')) {
        closeSearch()
    }

    disableBodyScroll(elNavDrawer)
    document.body.setAttribute('data-nav-drawer-open', 'true')
    elNavDrawer.setAttribute('aria-hidden', 'false')
    elNavDrawerToggle.setAttribute('aria-expanded', 'true')

    elLastLink.addEventListener('keydown', handleLastLinkTab)
    document.addEventListener('keyup', handleEscape)
    document.addEventListener('click', handleClickaway)

    // Delay focus to first link until after visibility is toggled
    setTimeout(() => elFirstLink.focus(), 500)
}

/**
 * Handle closing the nav and setting accessibility attributes and removing handlers
 */
const closeNavDrawer = () => {
    enableBodyScroll(elNavDrawer)
    document.body.removeAttribute('data-nav-drawer-open')
    elNavDrawerToggle.setAttribute('aria-expanded', 'false')
    elNavDrawer.setAttribute('aria-hidden', 'true')

    elLastLink.removeEventListener('keydown', handleLastLinkTab)
    document.removeEventListener('keyup', handleEscape)
    document.removeEventListener('click', handleClickaway)

    elNavDrawerToggle.focus()
}

/**
 * Close drawer when clicked outside
 */
const handleClickaway = () => {
    closeNavDrawer()
}

/**
 * Close drawer when escape is pressed
 * @param event {event}
 */
const handleEscape = (event) => {
    if (event.keyCode === 27) closeNavDrawer()
}

/**
 * Return focus to nav drawer toggle when focus
 * leaves the last item in the drawer
 * @param event {event}
 */
const handleLastLinkTab = (event) => {
    if (event.keyCode === 9 && !event.shiftKey) {
        // Timeout fixes odd bug where focused element also gets tab input and gets skipped
        setTimeout(() => elNavDrawerToggle.focus(), 1)
    }
}

const closeNavSection = (section) => {
    if (section.getAttribute('data-dropdown-open') === 'true') {
        section.removeAttribute('data-dropdown-open')
        section.setAttribute('aria-expanded', 'false')
        section.nextElementSibling.setAttribute('aria-hidden', 'true')
    }
}

const openNavSection = (section) => {
    section.setAttribute('data-dropdown-open', 'true')
    section.setAttribute('aria-expanded', 'false')
    section.nextElementSibling.setAttribute('aria-hidden', 'false')

    elNavDrawer.scrollTo(0, 0)
}

if (elNavDrawer) {
    dropdownToggles = elNavDrawer.querySelectorAll('[data-dropdown]')
    primaryLinks = Array.from(
        elNavDrawer.querySelectorAll('.navDrawer__navItem, .navDrawer__action')
    )
    elFirstLink = primaryLinks[0]
    elLastLink = primaryLinks.reverse()[0]

    elNavDrawerToggle.addEventListener('click', (event) => {
        event.stopPropagation()

        if (document.body.getAttribute('data-nav-drawer-open') === 'true') {
            closeNavDrawer()
            return
        }

        openNavDrawer()
    })

    elNavDrawer.addEventListener('click', (event) => event.stopPropagation())

    Array.from(dropdownToggles).forEach((toggle) => {
        toggle.addEventListener('click', (event) => {
            if (toggle.getAttribute('data-dropdown-open') === 'true') {
                closeNavSection(toggle)
                return
            }

            Array.from(dropdownToggles).forEach((toggle) => { closeNavSection(toggle) })
            openNavSection(toggle)
        })
    })
}

export { openNavDrawer, closeNavDrawer }
